import classNames from "classnames";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { Table } from "reactstrap";
import DataTableBody from "./DataTableBody";
import DataTableHeader from "./DataTableHeader";
import { columnPropType, rowIdPropType, rowPropType } from "./propTypes";
import "./DataTable.scss";
import * as ColumnAlignment from "./ColumnAlignment";
import * as ColumnType from "./ColumnType";
export default class DataTable extends PureComponent {
  static ColumnAlignment = ColumnAlignment;
  static ColumnType = ColumnType;
  static propTypes = {
    columns: PropTypes.arrayOf(columnPropType).isRequired,
    visibleColumnNames: PropTypes.arrayOf(PropTypes.string),
    rows: PropTypes.arrayOf(rowPropType).isRequired,
    selectedRowIds: PropTypes.arrayOf(rowIdPropType),
    striped: PropTypes.bool,
    hover: PropTypes.bool,
    bordered: PropTypes.bool,
    headerProps: PropTypes.object,
    headerRowProps: PropTypes.object,
    bodyProps: PropTypes.object,
    bodyRowProps: PropTypes.object,
    onRowClick: PropTypes.func,
    onRowSelectionChange: PropTypes.func,
    onAllRowsSelectionChange: PropTypes.func,
    rmClass: PropTypes.bool,
  };
  static defaultProps = {
    selectedRowIds: [],
    striped: false,
    hover: false,
    bordered: false,
  };
  getColumn = (name) => {
    const { columns } = this.props;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].name === name) {
        return columns[i];
      }
    }

    throw new Error(`Unknown table column '${name}'`);
  };

  render() {
    const {
      rmClass,
      className,
      columns,
      visibleColumnNames,
      rows,
      selectedRowIds,
      striped,
      hover,
      bordered,
      headerProps,
      headerRowProps,
      bodyProps,
      bodyRowProps,
      onRowClick,
      onRowSelectionChange,
      onAllRowsSelectionChange,
      ...otherProps
    } = this.props;
    const compositeClassName = classNames(rmClass == false && "data-table", className);
    const visibleColumns = visibleColumnNames ? visibleColumnNames.map(this.getColumn) : columns;
    const headerSelected = selectedRowIds.length > 0 && selectedRowIds.length === rows.length;
    return (
      <Table className={compositeClassName} striped={striped} hover={hover} bordered={bordered} {...otherProps}>
        <DataTableHeader
          {...headerProps}
          columns={visibleColumns}
          selected={headerSelected}
          rowProps={headerRowProps}
          onSelectionChange={onAllRowsSelectionChange}
        />

        <DataTableBody
          {...bodyProps}
          columns={visibleColumns}
          rows={rows}
          selectedRowIds={selectedRowIds}
          rowProps={bodyRowProps}
          onRowClick={onRowClick}
          onRowSelectionChange={onRowSelectionChange}
        />
      </Table>
    );
  }
}
